<template>
  <div id="formabox">
    <Title :title="$t('message.strid4')"></Title>
    <div class="form">
      <div class="formTitle">{{ $t("message.strid25") }}</div>
      <div class="item">
        <span class="lable">{{ $t("message.strid30") }}</span>
        <input
          class="content"
          type="text"
          :placeholder="$t('message.strid42') + $t('message.strid30')"
          v-model="form.nickname"
        />
      </div>
      <div class="item">
        <span class="lable">{{ $t("message.strid31") }}</span>
        <input
          class="content"
          type="number"
          :placeholder="$t('message.strid42') + $t('message.strid31')"
          v-model="form.accountID"
        />
      </div>
      <div class="item">
        <span class="lable">{{ $t("message.strid32") }}</span>
        <input
          class="content"
          type="text"
          :placeholder="$t('message.strid42') + $t('message.strid32')"
          v-model="form.level"
        />
      </div>
      <div class="item">
        <span class="lable">{{ $t("message.strid33") }}</span>
        <input
          class="content"
          type="text"
          :placeholder="$t('message.strid42') + $t('message.strid33')"
          v-model="form.rank"
        />
      </div>
      <div class="phone item">
        <span class="lable">{{ $t("message.strid34") }}</span>
        <input
          class="content"
          type="number"
          :placeholder="$t('message.strid42') + $t('message.strid34')"
          v-model="form.duration"
        />
      </div>
      <div class="item">
        <span class="lable">{{ $t("message.strid35") }}</span>
        <input
          class="content"
          type="text"
          :placeholder="$t('message.strid42') + $t('message.strid35')"
          v-model="form.model"
        />
      </div>
      <div class="item">
        <span class="lable">{{ $t("message.strid36") }}</span>
        <input
          class="content"
          type="text"
          :placeholder="$t('message.strid42') + $t('message.strid36')"
          v-model="form.email"
        />
      </div>
      <div class="item phone">
        <span class="lable">{{ $t("message.strid37") }}</span>
        <input
          class="content"
          type="text"
          :placeholder="$t('message.strid42') + $t('message.strid37')"
          v-model="form.bind"
        />
      </div>
      <div class="item radioBox">
        <p class="lable_reason">{{ $t("message.strid26") }}:</p>
        <label class="radio">
          {{ $t("message.strid39") }}
          <input type="radio" name="radio" value="1" v-model="form.reason" />
          <i></i>
        </label>
        <label class="radio">
          {{ $t("message.strid40") }}
          <input type="radio" value="2" name="radio" v-model="form.reason" />
          <i></i>
        </label>
        <label class="radio">
          {{ $t("message.strid41") }}
          <input type="radio" value="3" name="radio" v-model="form.reason" />
          <i></i>
        </label>
      </div>
      <div class="item txtBox">
        <p class="lable">{{ $t("message.strid27") }}</p>
        <textarea
          class="txt"
          v-model="form.downlink"
          :placeholder="$t('message.strid42') + $t('message.strid27')"
        ></textarea>
      </div>
      <div class="item txtBox">
        <p class="lable">{{ $t("message.strid28") }}</p>
        <textarea class="txt desc" v-model="form.desc"
          :placeholder="$t('message.strid42')+ $t('message.strid28')"
        ></textarea>
      </div>

      <div class="btn" @click="submit">submit</div>
    </div>
  </div>
</template>

<script>
import { sendAppeal, getCode } from "@/proxy/index";
import Title from "@/components/Title";

export default {
  components: {
    Title,
  },
  data() {
    return {
      inviteCode: "invite",
      showMask: false,
      id: "",
      form: {},
      errCode: {},
    };
  },
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  mounted() {
    document.querySelector("#loadingMask").style.display = "none";
    //取消请求
    this.getCode();
    this.id = this.$route.query.id;
  },
  methods: {
    getCode(lang) {
      getCode(window.localStorage.getItem("selfservicelang")).then((res) => {
        (res.data.errcode || []).map((item) => {
          this.errCode[item.code] = item.lang || "";
        });
      });
    },
    submit() {
      if (Object.keys(this.form).length == 11) {
        sendAppeal(
          window.localStorage.getItem("selfservicelang"),
          this.id,
          JSON.stringify(this.form),
          Cookies.get("token")
        ).then((res) => {
          if (res.data.code == 0) {
            //
            layer.open({
              content: `success`,
              skin: "msg",
              time: 2,
            });
            this.$router.push({
              path: "punish",
            });
          } else if (res.data.code == -20020) {
            Cookies.remove("token");
            this.$router.push({
              path: "home",
            });
          } else {
            layer.open({
              content: `Service Error ${res.data.code}`,
              skin: "msg",
              time: 2,
            });
          }
        });
      } else {
        layer.open({
          content: this.$t('message.strid46'),
          skin: "msg",
          time: 2,
        });
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/views/form.scss";
</style>
